import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store';
import { login as loginAction, register as registerAction, logout as logoutAction, clearMessages } from '../store/authSlice';
import { setAnalyticsUser, trackEvent } from '../utils/analytics';

export const useAuth = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { token, user, isLoading, error, message } = useSelector((state: RootState) => state.auth);

  const login = async (email: string, password: string) => {
    await dispatch(loginAction({ email, password })).unwrap();
  };

  const register = async (email: string, password: string) => {
    await dispatch(registerAction({ email, password })).unwrap();
  };

  const logout = () => {
    trackEvent('logout');
    setAnalyticsUser(null);
    dispatch(logoutAction());
  };

  const clear = () => {
    dispatch(clearMessages());
  };

  return {
    token,
    user,
    isLoading,
    error,
    message,
    login,
    register,
    logout,
    clearMessages: clear,
  };
};